<div class="mat-elevation-z8">
    <div class="table-responsive text-center justify-content-center" style="
    font-size: 14px;
    margin-bottom: 20px;
    text-align: center;
    vertical-align: center;
  ">
        <p-table #dt1 [value]="Transactions" dataKey="id" [rows]="10" [paginator]="true" [scrollable]="true"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10, 25, 50]" [globalFilterFields]="['status','invoice','expirydate']">
            <ng-template pTemplate="caption">
                <div class="table-header float-right">
                    <div class="ui-table-globalfilter-container">
                        <input type="text" pInputText size="50" placeholder="Search"
                            (input)="dt1.filterGlobal($event.target.value, 'contains')"
                            style="width: 250px; margin-left: 75%" />
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="name" style="font-weight: bold;width:auto;text-align: center;">
                        License <p-sortIcon field="name"></p-sortIcon>
                    </th>
                    <th pSortableColumn="status" style="font-weight: bold;width:auto;text-align: center;">
                        Status <p-sortIcon field="status"></p-sortIcon>
                    </th>
                    <th pSortableColumn="created_at" style="font-weight: bold;width:auto;text-align: center;">
                        Created Date <p-sortIcon field="created_at"></p-sortIcon>
                    </th>
                    <th style="font-weight: bold;width:auto;text-align: center;">
                        Invoice 
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-transaction>
                <ng-container *ngIf="transaction.subscription_invoice; else noInvoice">
                    <ng-container *ngFor="let invoice of transaction.subscription_invoice;">
                        <tr>
                            <td style="width:auto;text-align: center;">
                                <span>{{ transaction.provider_license.license['name'] }}</span>
                            </td>
                            <td style="width:auto;text-align: center;">
                                <span>{{ transaction.status }}</span>
                            </td>
                            <td style="width:auto;text-align: center;">
                                <span>{{ invoice.created_at | date: 'medium'}}</span>
                            </td>
                            <td style="width:auto;text-align: center;">
                                <p-button (click)="getInvoice(invoice.id)" icon="pi pi-download"
                                    label="Download"></p-button>
                            </td>
                        </tr>
                    </ng-container>
                </ng-container>
                <ng-template #noInvoice>
                    <tr>
                        <td style="width:auto;text-align: center;">
                            <span>{{ transaction.provider_license['license']['name'] }}</span>
                        </td>
                        <td style="width:auto;text-align: center;">
                            <span>{{ transaction.status }}</span>
                        </td>
                        <td style="width:auto;text-align: center;">
                            <span>{{ transaction.created_at | date: 'medium'}}</span>
                        </td>
                        <td style="width:auto;text-align: center;">
                            N/A
                        </td>
                    </tr>
                </ng-template>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="8">No Transactions found.</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft"> </ng-template>
            <ng-template pTemplate="paginatorright"> </ng-template>
        </p-table>
    </div>

    <div class="ui-g-12">
        <app-error-messages [api_result]="this.providertransactions.create_api_result"></app-error-messages>
        <app-error-messages [api_result]="this.invoicePdf.create_api_result"></app-error-messages>
    </div>
</div>